// extracted by mini-css-extract-plugin
export default {"installerIcon":"row_installerIcon__aIklA","ownerIcon":"row_ownerIcon__WytKq"};